import React, { FC, FormEvent } from 'react';
import { Controller, FieldValues, UseFormReturn } from 'react-hook-form';
import { Radio, Typography } from '@sravni/react-design-system';
import cn from 'classnames';
import styles from './styles.module.scss';
import { FORM_FIELDS } from '../../../../../../../../constants';

interface RadioProps {
    options: { label: string; value: string }[];
    fieldName: string;
    form: UseFormReturn<FieldValues, any>;
    disabled?: boolean;
}

const { Text } = Typography;

export const RadioField: FC<RadioProps> = (props) => {
    const { options, fieldName, form, disabled } = props;

    const {
        control,
        formState: { dirtyFields: _ },
    } = form;

    const onChangeHandler = (
        event: FormEvent<HTMLInputElement>,
        onChange?: (event: FormEvent<HTMLInputElement>) => void,
    ) => {
        if (onChange) {
            onChange(event);
        }

        event.target.dispatchEvent(
            new CustomEvent('manualBlur', {
                bubbles: true,
                detail: {
                    fields: [fieldName],
                },
            }),
        );
    };

    return (
        <div className={styles['radio-container']}>
            <Controller
                control={control}
                name={fieldName}
                render={({ field: { onChange, value: checkedValue, onBlur } }) => (
                    <div className={styles['radio-container_content']}>
                        {options.map((item) => (
                            <Radio
                                key={item.value}
                                checked={checkedValue === item.value}
                                onChange={(e) => onChangeHandler(e, onChange)}
                                onBlur={onBlur}
                                value={item.value}
                                disabled={disabled}
                                className={cn(styles['radio-btn'], {
                                    [styles['radio-btn_checked']]: checkedValue === item.value,
                                })}>
                                <Text size={16}>{item.label}</Text>
                            </Radio>
                        ))}
                    </div>
                )}
            />
        </div>
    );
};
